import { render, staticRenderFns } from "./MitoDisease.vue?vue&type=template&id=272d8cd8&scoped=true"
import script from "./MitoDisease.vue?vue&type=script&lang=js"
export * from "./MitoDisease.vue?vue&type=script&lang=js"
import style0 from "./MitoDisease.vue?vue&type=style&index=0&id=272d8cd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272d8cd8",
  null
  
)

export default component.exports